<template>
  <div class="player__cdn vjs-live" v-if="PlayerReady">
    <video-player :autoplay="videoOptions?.autoplay" :options="videoOptions" :panorama="panorama"
      :rightClick="handleContextMenu" :leftClick="handleLeftClick" :showSettingsModal="handleShowSettingsModal"
      :showShareModal="handleShowShareModal" :isAllModalsClosed="isAllModalsHidden" :setPlayer="setPlayer"
      :videoData="videoData" :isLive="true"   @closeModals="closeModals" />
    <div id="components">
      <right-click-menu v-if="showContextMenu" :contextMenuPos="contextMenuPos" :showStatsModal="handleShowStatsModal"
        :isRepeat="isRepeat" />
      <StatsModal v-if="showStatsModal" :closeStatsModal="handlCloseStatsModal" :player="mainPlayer"
        :videoData="videoData" />
      <SettingsModal v-if="showSettingsModal" :closeSettingsModal="handlCloseSettingsModal" :player="mainPlayer"
        :videoRef="player" :currentQualityIndex="currentQualityIndexUpdate" :currentRateIndex="currentRateIndexUpdate" :isLive="true"/>
      <ShareModal v-if="showShareModal" :player="mainPlayer" :showShareModal="handleShowShareModal"
        :closeShareModal="handlCloseShareModal" :playerInfos="videoData" :pageURL="pageURL" />
      <div v-show="infoOptions &&
        hasInformations &&
        (!isBo || (isBo && isChapters)) &&
        PlayerReady
        ">
        <button tabindex="0" class="info-btn" @click="handleShowInfosModal" v-html="SVG.INFO_SVG">
        </button>
       
        <InfosModal v-if="showInfoModal" :isBo="isBo" :isChapters="isChapters" :information="information" :poster="poster"
          :player="mainPlayer" :mediaId="+getMediaId" :statsParams="statsParams" :mediaType="getMediaType"
          :closeInfosModal="handlCloseInfosModal">
        </InfosModal>
      </div>
    </div>
  </div>
  <div class="loader" v-else-if="!PlayerReady && !PlayerError"></div>
  <div class="error-container" v-else>
    <img class="error-img" src="../assets/img/404.png" />
  </div>
</template>
<script >
import { defineComponent } from "vue";
import { useRoute } from "vue-router";
import { noImage } from "../assets/img/constants/constants";
import VideoPlayer from "../views/VideoPlayer.vue";
import InfosModal from "../components/parts/InfosModal/InfosModal.vue";
import RightClickMenu from "../components/parts/RightClickMenu/RightClickMenu.vue";
import StatsModal from "../components/parts/StatsModal/StatsModal.vue";
import SettingsModal from "../components/parts/SettingsModal/SettingsModal.vue";
import ShareModal from "../components/parts/ShareModal/ShareModal.vue";
import {SVG} from "../components/utils/const";
import { mapActions } from "vuex";
import axios from "axios";
export default defineComponent({
  name: "emp-player",
  components: {
    VideoPlayer,
    RightClickMenu,
    StatsModal,
    SettingsModal,
    ShareModal,
    InfosModal,
},
  props: [
    "standalone",
    "query",
    "url",
    "fileName",
    "autoplay",
    "loop",
    "controls",
    "src",
    "refPlayer",
  ],
  data() {
    return {
      SVG:SVG,
      loaded: false,
      parsedStandalone: null,
      parsedQuery: null,
      parsedUrl: "",
      videoFileName: "",
      player: {},
      mainPlayer: {},
      playerCSS: false,
      count: 0,
      options: {},
      playerHost: "",
      ApiHost: "",
      ApiToken: "",
      PlayerReady: false,
      PlayerError: false,
      panorama: false,
      showContextMenu: false,
      showStatsModal: false,
      showSettingsModal: false,
      showInfoModal: false,
      showShareModal: false,
      isRepeat: false,
      currentQualityIndex: -1,
      currentRateIndex: 3,
      contextMenuPos: {
        xPos: 0,
        yPos: 0,
      },
      videoData: {
        playerOptions: {
          videoId: "",
          liveId: "",
          poster: "",
        },
      },
      videoOptions: {
        autoplay: true,
        controls: true,
        responsive: true,
        sources: [
          {
            src: "",
            type: "",
          },
        ],
        loop: false,
        vhs: { withCredentials: false },
      },

      isBo: false,
      isChapters: false,
      information: {
        primary: {
          image: "",
        },
        share: {},
        exportOptions: {},
        files: [],
        sendMailOptions: {},
        chapters: [],
        client: "",
      },
      infoOptions: {},
      crypText: "",
      queryParams: {},
    };
  },
  mounted() {
    const route = useRoute();
    this.crypText = route.params.ct.toString();
    this.queryParams = route.query;
    this.initData();
  },
  updated() {
    const mainVideoContainer = document.getElementById("vjs_video_3");
    const allComponents = document.getElementById("components");
    const video = document.querySelector(".vjs-tech");
    const poster = document.querySelector(".vjs-poster");
    mainVideoContainer?.appendChild(allComponents);
    mainVideoContainer?.addEventListener("click", (e) => {
      if ([video, mainVideoContainer, poster].includes(e.target)) {
        this.handlCloseSettingsModal();
        this.handlCloseInfosModal();
        this.handlCloseStatsModal();
        this.handlCloseShareModal();
      }
    });
  },
  methods: {
    ...mapActions(['updateVideoInfos']),
    async initData() {
      let src = this.src;
      if (!src) {
        src = "prn44_jf19_1442";
      }
      if (src) {
        await axios
          .get(
            `https:${window.process?.env.URL_LIVE_INTRANET === window.location.hostname ? "//" + window.process?.env.URL_LIVE_INTRANET + "/player" : window.process?.env?.API_PLAYER}/api/video/live/player/${this.crypText}/infos`,
              {
              headers: {
                authorization: `Bearer ${window.process?.env?.API_TOKEN}`,
              },
            }
          )
          .then((resp) => {
            const responseData = resp.data?.data;
            this.videoOptions = responseData?.playerOptions;
            this.videoOptions.vhs = { withCredentials: true };
            this.videoOptions.responsive = true;
            this.videoData = responseData;
            this.isBo = responseData?.paramsOptions && responseData?.paramsOptions?.isBO;
            this.infoOptions = responseData?.infoOptions;
            this.panorama = responseData?.panoramaOptions;
            this.information = {
              primary: responseData?.infoOptions || {},
              share: responseData?.shareOptions || {},
              exportOptions: responseData?.exportOptions || {},
              files: responseData?.files || [],
              sendMailOptions: responseData?.sendMailOptions,
              chapters: responseData?.rmOptions?.chapters || [],
              client: responseData?.client,
            };
            this.$nextTick(() => {
              this.updateVideoInfos(resp.data?.data)
              this.PlayerReady = true;
            })
          })
          .catch(() => {
            this.PlayerError = true;
          });
      } else {
        this.PlayerError = true;
        this.playerHost = "/404";
      }
    },
    play() {
      this.mainPlayer.play();
    },
    pause() {
      this.mainPlayer.pause();
    },
    currentQualityIndexUpdate(i) {
      if (i >= -1) {
        this.currentQualityIndex = i;
      } else {
        return this.currentQualityIndex;
      }
    },
    currentRateIndexUpdate(i) {
      if (i >= 0) {
        this.currentRateIndex = i;
      }
      return this.currentRateIndex;
    },
    setPlayer(p, mainPlayer) {
      this.player = p;
      this.mainPlayer = mainPlayer;
      this.isRepeat=mainPlayer?.options_?.loop;
    },
    handleShowSettingsModal() {
      if (!this.showSettingsModal) {
        this.handlCloseInfosModal();
        this.handlCloseStatsModal();
        this.handlCloseShareModal();
      }
      this.showSettingsModal = !this.showSettingsModal;
      this.handleLeftClick();
    },

    handlCloseSettingsModal() {
      this.showSettingsModal = false;
    },
     
    handleShowInfosModal() { 
      if (!this.showInfoModal) {
        this.handlCloseStatsModal();
        this.handlCloseSettingsModal();
        this.handlCloseShareModal();
      }

      this.showInfoModal = !this.showInfoModal;
      this.handleLeftClick();
    },
    handlCloseInfosModal() {
      this.showInfoModal = false;
    },
    handleShowStatsModal() {
      if (!this.showStatsModal) {
        this.handlCloseInfosModal();
        this.handlCloseSettingsModal();
        this.handlCloseShareModal();
      }

      this.showStatsModal = !this.showStatsModal;
      this.handleLeftClick();
    },
    handlCloseStatsModal() {
      this.showStatsModal = false;
    },
    handleShowShareModal() {
      if (!this.showShareModal) {
        this.handlCloseInfosModal();
        this.handlCloseStatsModal();
        this.handlCloseSettingsModal();
      }
      this.showShareModal = !this.showShareModal;
    },
    handlCloseShareModal() {
      this.showShareModal = false;
    },
    handleLeftClick() {
      if (this.showContextMenu) this.showContextMenu = false;
    },
    handleContextMenu(e) {
      e.preventDefault();
      this.showContextMenu = true;
      this.contextMenuPos.xPos = e.clientX;
      this.contextMenuPos.yPos = e.clientY;
    },
    closeModals() {
      this.showContextMenu = false;
      this.showStatsModal = false;
      this.showInfoModal = false;
      this.showSettingsModal = false;
      this.showShareModal = false;
    },
  },
  computed: {
    getMediaId() {
      if (this.videoData.playerOptions.videoId) {
        return this.videoData.playerOptions.videoId;
      } else {
        return this.videoData.playerOptions.liveId;
      }
    },
    getMediaType() {
      if (this.videoData.playerOptions.videoId) {
        return "vod";
      } else {
        return "live";
      }
    },
    poster() {
      const image = this.videoData.playerOptions
        ? this.videoData.playerOptions.poster
        : "";
      return image !== "" && image !== null
        ? this.videoData.playerOptions.poster
        : noImage;
    },
    pageURL() {
      return window.location.href;
    },
    hasInformations() {
      return (
        this.information &&
        Object.keys(this.information).length > 0 &&
        (Object.keys(this.information.primary).length > 0 ||
          Object.keys(this.information.share).length > 0 ||
          Object.keys(this.information.exportOptions).length > 0 ||
          this.information.files.length > 0 ||
          this.information.chapters.length > 0)
      );
    },
    isDarkSkin() {
      return this.information && Object.keys(this.information).length > 0;
    },
    statsParams() {
      return { videoId: this.getMediaId, client: this.information.client };
    },
    isAllModalsHidden() {
      return (
        this.showContextMenu ||
        this.showStatsModal ||
        this.showSettingsModal ||
        this.showInfoModal 
      );
    },
  },
});
</script>

<style>
.vjs-live .vjs-progress-control.vjs-control {
  display: block !important;
}
</style>
